import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { useLastPickSample } from "contexts/lastPickSample";
import { selectPicker } from "features/render/renderSlice";
import { Picker } from "features/render/types";
import { selectIsProcoreDesign } from "slices/explorer";

export function TemporaryCoordinateLabelOverlay() {
    const lastPickSample = useLastPickSample();
    const {
        state: { view },
    } = useExplorerGlobals();
    const isCoordinatesPicker = useAppSelector(selectPicker) === Picker.Coordinates;
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);

    const shouldShowLabel = lastPickSample && view;

    if (!shouldShowLabel) {
        return null;
    }
    return isCoordinatesPicker && isProcoreDesign ? <g id="temp-cursor-coordinate-label-overlay"></g> : null;
}
